import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const useURLQuery = () => {
  const { search } = useLocation();
  const searchparams = useMemo(() => new URLSearchParams(search), [search]);
  return searchparams;
}

export default useURLQuery